import { useForm, Controller } from 'react-hook-form';

interface ApproveChangeRequestModalProps {
    modalOpen: boolean;
    setModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
    onConfirm?: () => void;
    mipConfirmed?: boolean;
    setMipConfirmed?: React.Dispatch<React.SetStateAction<boolean>>;
    hasAchDocument?: boolean;
}

const ApproveChangeRequestModal = ({
    modalOpen,
    setModalOpen,
    onConfirm,
    mipConfirmed = false,
    setMipConfirmed,
    hasAchDocument = false,
}: ApproveChangeRequestModalProps) => {
    const { register, handleSubmit, formState, reset } = useForm({
        defaultValues: {
            note: '',
        },
    });

    const { isSubmitting } = formState;

    const onSubmit = async (data: any) => {
        if (onConfirm) {
            onConfirm();
        }
        reset({ note: '' });
        setModalOpen(false);
    };

    const handleCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (setMipConfirmed) {
            setMipConfirmed(e.target.checked);
        }
    };

    return (
        <>
            {modalOpen && (
                <div
                    className='fixed inset-0 z-[99999] flex items-center justify-center bg-black bg-opacity-75'
                    onClick={() => setModalOpen(false)}
                >
                    <div
                        onClick={(e) => e.stopPropagation()}
                        className='relative w-full max-w-xl rounded-lg bg-white shadow-lg'
                    >
                        <div className='p-7'>
                            <h2 className='mb-4 text-3xl font-semibold'>
                                Approve Vendor Change Requests
                            </h2>
                            <p>
                                Ensure that all of the changes to the vendor
                                have been appropriately made in MIP. Once that
                                is done, you can accept them and re-verify the
                                vendor to update their information.
                            </p>
                            {hasAchDocument && (
                                <p className='mt-4 font-bold text-danger'>
                                    The uploaded ACH document will be removed
                                    once you approve. If you need a copy, cancel
                                    and download it first.
                                </p>
                            )}

                            <div className='mt-6'>
                                <label className='flex items-center cursor-pointer'>
                                    <input
                                        type='checkbox'
                                        className='form-checkbox h-5 w-5 text-primary focus:ring-primary'
                                        checked={mipConfirmed}
                                        onChange={handleCheckboxChange}
                                    />
                                    <span className='ml-2 font-medium'>
                                        I confirm that I have updated the vendor information in MIP
                                    </span>
                                </label>
                            </div>

                            <div className='flex gap-[16px]'>
                                <button
                                    onClick={() => setModalOpen(false)}
                                    type='button'
                                    className='mt-[30px]  rounded-full border-[2px] px-[24px] py-[7px] text-[14px]/[18px] font-bold uppercase transition-colors duration-500 hover:border-[#E6F7F8] hover:bg-[#E6F7F8]'
                                >
                                    Cancel
                                </button>
                                <button
                                    type='button'
                                    className={`mt-[30px] rounded-full border-[2px] border-warning bg-warning px-[24px] py-[7px] text-[14px]/[18px] font-bold uppercase  transition-colors duration-500 ${isSubmitting || !mipConfirmed
                                        ? 'cursor-not-allowed opacity-50'
                                        : 'hover:border-[#E6F7F8] hover:bg-[#E6F7F8] hover:text-black'
                                        }`}
                                    onClick={handleSubmit(onSubmit)}
                                    disabled={isSubmitting || !mipConfirmed}
                                >
                                    {isSubmitting
                                        ? 'Saving...'
                                        : 'Approve & Re-verify Vendor'}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default ApproveChangeRequestModal;
